import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/vacaciones";

class VacacionesService {
    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVacacionesProgramadasPorFecha(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-vacaciones-programadas-por-fecha`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async programarVacaciones(params) {
        try {
            const data = await zergApi.post(`${prefix}/programar-vacaciones`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async reprogramarVacaciones(params) {
        try {
            const data = await zergApi.post(`${prefix}/reprogramar-vacaciones`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVacacionesProgramadasPorEmpleado(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-vacaciones-programadas-por-empleado`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVacacionesResumen(params) {
        try {
            const data = await zergApi.post(`${prefix}/resumen`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataProgramarVacaciones(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-data-programar-vacaciones`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async destroy(params) {
        try {
            const data = await zergApi.post(`${prefix}/destroy`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const response = await zergApi.post(`${prefix}/excel`, params, {
                responseType: "blob",
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
    async getVacacionesPorPagar(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-vacaciones-por-pagar`, params);
            return data;
        }
        catch (error) {
            throw error;
        }
    }

    async pagarVacaciones(params) {
        try {
            const data = await zergApi.post(`${prefix}/pagar-vacaciones`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    // async getDiscountFractionsById(params) {
    //     try {
    //         const data = await zergApi.post(`${prefix}/get-discount-fractions-by-id`, params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // async show(params) {
    //     try {
    //         const data = await zergApi.post(`${prefix}/show`, params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // async update(params) {
    //     try {
    //         const data = await zergApi.post(`${prefix}/update`, params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // async destroy(params) {
    //     try {
    //         const data = await zergApi.post(`${prefix}/destroy`, params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }


    // async approve(params) {
    //     try {
    //         const data = await zergApi.post(`${prefix}/approve`, params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }
    async getCalendarioVacaciones(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-calendario-vacaciones`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new VacacionesService();